
import { Logger } from '../util/log.js';

(function($){

    var $controller  = {

        debug: false,

        logger: null,

        selector: '.slick-slider',
        collection: null,

        init: function() {
            this.logger = new Logger({debug: this.debug});
            this.collection = $(this.selector);
            if(this.collection.length > 0) {
                this.listen();
            }
        },
        
        listen: function() {

            /**
             *  Move the nav into a box.
             */
            this.collection.on('init', function() {
                var $nav = $('<nav></nav>');
                var $this = $(this);
                if($this.find('.slick-slide').length > 1) {
                    $this.append($nav);
                    var $elements = [
                        '.slick-prev',
                        '.slick-dots',
                        '.slick-next'
                    ];
                    $.each($elements, function($idx, $el) {
                        $($el, $this).appendTo($nav);
                    })
                } else {
                    // remove dots
                    $this.find('.slick-dots').remove();
                }
            });

            /**
             *  Initialize slick.
             */
            this.collection.each(function() {
                var $this = $(this);
                var $defaults = {
                    cssEase: 'linear',
                    infinite: true,
                    autoplay: !$controller.debug,
                    arrows: true,
                    dots: false,
                    fade: true,
                    pauseOnFocus: true,
                    speed: 500,
                    autoplaySpeed: 4000,
                    nextArrow: '<a href="#" class="slick-next"><i class="icon2-icon-arrow--right"><span class="screen-reader-text">Go to Next Slide</span></i></a>',
                    prevArrow: '<a href="#" class="slick-prev"><i class="icon2-icon-arrow--left"><span class="screen-reader-text">Go to Previous Slide</span></i></a>',
                };
                var $options = $this.data('slick');
                $options = $.extend($defaults, $options);
                $this.slick($options);
            });

        },

        log: function() {
            this.logger.store.apply(this.logger, arguments);
        }

    };

    $controller.init();

})(jQuery, Logger);


// WEBPACK FOOTER //
// ./tbo/js/widget/slick-slider.js